export const formatError = (error, t) => {
  const { response = {} } = error;
  const { status } = response;
  if (status === 401) {
    return t('INVALID_CREDENTIALS');
  }
  return t('COMMON:GENERIC_ERROR');
};
